import {combineReducers} from 'helpers';
import {index} from './index';
import {types} from './types';

export const notes = combineReducers({types, index});
